var regPhoneCodeController = {
    elForm: $('#regPhoneCodeForm'),
    regModalPhoneCode: $('#regModalPhoneCode'),
    regModalSetPass: $('#regModalSetPass'),
    code: '',
    submitting: false,
    init: function()
    {
        regPhoneCodeController.elForm.find('.error-text').hide();
        regPhoneCodeController.elForm.find('.js-reg-countdown').hide();
        regPhoneCodeController.code = regPhoneCodeController.elForm.find('.js-input-code').val();

        regPhoneCodeController.elForm.on('keyup keypress', function(e) {
            var keyCode = e.keyCode || e.which;
            if (keyCode === 13) {
                e.preventDefault();

                return false;
            }
        });

        regPhoneCodeController.elForm.find('.js-input-code').on('click change keyup blur input', function() {
            regPhoneCodeController.code = $(this).val().trim();

            if(regPhoneCodeController.code.length === 4) {
                regPhoneCodeController.submitForm();
            } else {
                regPhoneCodeController.clearForm();
            }

            return false;
        });
    },
    submitForm: function()
    {
        if (regPhoneCodeController.submitting) {
            return false;
        }

        if (!regPhoneCodeController.validateForm()) {
            regPhoneCodeController.showError();

            return false;
        }

        regPhoneCodeController.submitting = true;

        $.post(
            regPhoneCodeController.elForm.attr('action'),
            regPhoneCodeController.elForm.serialize(),

            function(data) {
                if (data.success) {
                    regPhoneCodeController.regModalSetPass.modal('show');
                    regPhoneCodeController.regModalSetPass.find('.js-input-username').val(
                        regPhoneCodeController.elForm.find('.js-input-phone-number').val()
                    );
                    regPhoneCodeController.regModalSetPass.find('.js-input-phone-country-code').val(
                        regPhoneCodeController.elForm.find('.js-input-phone-country-code').val()
                    );
                    regPhoneCodeController.regModalSetPass.find('.js-input-reg-by-email').val(0);
                    regPhoneCodeController.regModalSetPass.find('.js-input-reg-by-phone').val(1);
                    regPhoneCodeController.regModalPhoneCode.modal('hide');
                } else {
                    if(data.message) {
                        regPhoneCodeController.regModalPhoneCode.find('.error-text').text(data.message);
                        regPhoneCodeController.showError();
                    }
                }
            }, 'json').always(function() {
                regPhoneCodeController.submitting = false;
            });
    },
    validateForm: function()
    {
        regPhoneCodeController.clearForm();

        return ($.isNumeric(regPhoneCodeController.code) && regPhoneCodeController.code.length === 4);
    },
    clearForm: function()
    {
        regPhoneCodeController.elForm.find('.form-group').removeClass('has-error');
        regPhoneCodeController.elForm.find('.error-text').hide();
    },
    showError: function()
    {
        regPhoneCodeController.elForm.find('.form-group').addClass('has-error');
        regPhoneCodeController.elForm.find('.error-text').show();
    }
};

$(function(){
    regPhoneCodeController.init();
});